import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { CreateScorecard } from '../ai/scorecard'

interface ImportedFormState {
  importedForm: CreateScorecard | null
}

const initialState: ImportedFormState = {
  importedForm: null,
}

export const importedFormSlice = createSlice({
  name: 'importedForm',
  initialState,
  reducers: {
    setImportedForm: (state, action: PayloadAction<CreateScorecard>) => {
      state.importedForm = action.payload
    },
    clearImportedForm: () => initialState,
  },
})

export const { setImportedForm, clearImportedForm } = importedFormSlice.actions

export const selectImportedForm = (state: RootState) => state.forms.importedForm

export default importedFormSlice.reducer
